import type {TextHighlightType} from 'app/comments/types';

export function lightenColor(color: string, amount: number) {
  // Extract RGB components from the hex string (e.g., '#FF0000')
  const r = parseInt(color.slice(1, 3), 16); // 'FF' -> 255
  const g = parseInt(color.slice(3, 5), 16); // '00' -> 0
  const b = parseInt(color.slice(5, 7), 16); // '00' -> 0

  // Calculate new RGB values by blending with white
  const newR = Math.round(r * (1 - amount) + 255 * amount);
  const newG = Math.round(g * (1 - amount) + 255 * amount);
  const newB = Math.round(b * (1 - amount) + 255 * amount);

  // Convert new RGB values to two-digit hex strings
  const rHex = newR.toString(16).padStart(2, '0').toUpperCase();
  const gHex = newG.toString(16).padStart(2, '0').toUpperCase();
  const bHex = newB.toString(16).padStart(2, '0').toUpperCase();

  // Return the new hex color
  return `#${rHex}${gHex}${bHex}`;
}
export const TEXT_HIGHLIGHT_CLASS_PREFIX = 'text-highlight-';
export const TEXT_HIGHLIGHT_ANIMATION_PREFIX = 'highlightHoverAnimation';

// used to indicate that this text should have appropriate background-color applied.
export const HIGHLIGHT_TEXT_CLASS = 'highlight-text';
export const HIGHLIGHT_HOVERED_CLASS = 'highlight-hovered';

export function adjustHighlightParams(
  attributes: Record<string, string>,
  highlight: TextHighlightType
) {
  let highlightClass = `${TEXT_HIGHLIGHT_CLASS_PREFIX}${highlight.id}`;

  if ((attributes.class || '').indexOf(HIGHLIGHT_TEXT_CLASS) === -1) {
    highlightClass += ` ${HIGHLIGHT_TEXT_CLASS}`;
  }

  attributes.class = `${attributes.class || ''} ${highlightClass}`;
}

// used for fake stepIds used in procedure description and for policies.
export const HIGHLIGHT_PROCEDURE_DESCRIPTION_STEPID = 'procedure-description';
export const HIGHLIGHT_PROCEDURE_TITLE_STEPID = 'procedure-title';
export const HIGHLIGHT_PROCEDURE_STEP_TITLE_PREFIX = 'step-title';
export const HIGHLIGHT_POLICY_STEPID = 'policy-stepid';
export const HIGHLIGHT_POLICY_TITLE = 'policy-title';
export const HIGHLIGHT_PROCESS_STEP_TITLE_PREFIX = 'process-step-title';
export const HIGHLIGHT_PROCESS_TITLE_STEPID = 'process-title';
export const HIGHLIGHT_PROCESS_DESCRIPTION_STEPID = 'process-description';
